import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function ConfirmationCheck({
	size = 20,
	color,
	strokeWidth = 0.25,
	sx,
	...props
}) {
	const theme = useTheme();
	const resolvedColor = color || theme.palette.success.main;

	return (
		<CheckCircleOutlineIcon
			{...props}
			sx={{
				fontSize: size,
				flexShrink: 0,
				'& path': {
					fill: resolvedColor,
					stroke: resolvedColor,
					strokeWidth,
				},
				...sx,
			}}
		/>
	);
}

ConfirmationCheck.propTypes = {
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string,
	strokeWidth: PropTypes.number,
	sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(ConfirmationCheck);
